import React, { forwardRef } from 'react';

import { Tooltip } from 'uikit/tooltips';

const AiGenerateButtonWrapper = forwardRef(
  // eslint-disable-next-line react/prop-types
  ({ children, disabledText = '', isDisabled = false }, ref) => {
    if (isDisabled) {
      return (
        <Tooltip content={disabledText}>
          <span ref={ref}>{children}</span>
        </Tooltip>
      );
    }

    return children;
  },
);

export default AiGenerateButtonWrapper;
